export enum BrandingHeaderType {
	Classic = 'Classic',
	Nettrix = 'Nettrix',
	TwoTier = 'TwoTier'
}
